import MDCopyField from 'components/SSOConfigFields/MDCopyField';
import { useAuthContext } from 'contexts/AuthContext';
import React, { useMemo } from 'react';

const DnsRecordInfo: React.FC = () => {
	const {
		authRes: { projectId, tenantId, domainVerificationTxt }
	} = useAuthContext();

	const txtValue = useMemo(() => {
		if (domainVerificationTxt) {
			return domainVerificationTxt;
		}
		/* istanbul ignore next  */
		if (!projectId || !tenantId) {
			return null;
		}
		return `domain-verification=${btoa(`${projectId}-${tenantId}`)}`;
	}, [domainVerificationTxt, projectId, tenantId]);

	return (
		<>
			<MDCopyField
				displayName={intl.tr('domainVerification.dnsRecordInfo.type')}
				fieldName="dns-record-type"
				value="TXT"
			/>
			<MDCopyField
				displayName={intl.tr('domainVerification.dnsRecordInfo.name')}
				fieldName="dns-record-name"
				value="@"
			/>
			<MDCopyField
				displayName={intl.tr('domainVerification.dnsRecordInfo.value')}
				fieldName="dns-record-value"
				disabled={!txtValue}
				value={txtValue}
			/>
		</>
	);
};

export default DnsRecordInfo;
